import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import API_BASE_URL from '../config/api';
import '../styles/Dashboard.css';

const Dashboard = ({ user }) => {
  const [stats, setStats] = useState({
    totalNotes: 0,
    completedTasks: 0,
    totalQuizzes: 0,
    daysConnected: 0,
    partnerName: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/stats`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const features = [
    {
      title: 'Love Notes',
      icon: '💕',
      description: 'Sweet daily messages',
      path: '/notes',
      color: 'var(--primary-color)',
      count: stats.totalNotes
    },
    {
      title: 'To-Do List',
      icon: '📝',
      description: 'Shared tasks & plans',
      path: '/todos',
      color: 'var(--secondary-color)',
      count: stats.completedTasks
    },
    {
      title: 'Quiz Game',
      icon: '🎯',
      description: 'Custom couple quizzes',
      path: '/quiz',
      color: '#FF6B9D',
      count: stats.totalQuizzes
    },
    {
      title: 'Profile',
      icon: '👤',
      description: 'Your love profile',
      path: '/profile',
      color: '#9C27B0',
      count: user?.stats?.quizScore || 0
    }
  ];

  return (
    <div className="dashboard">
      <div className="container">
        <div className="dashboard-header">
          <div className="welcome-section">
            <div className="heart-decoration">💖</div>
            <h1>Welcome back, {user?.name}!</h1>
            <p className="welcome-subtitle">Your love space awaits ✨</p>
            {stats.partnerName && (
              <p className="partner-info">💕 Connected with {stats.partnerName}</p>
            )}
          </div>
          
          <div className="couple-info">
            <div className="couple-badge">
              👫 Couple Code: {user?.coupleId}
            </div>
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">💌</div>
            <div className="stat-info">
              <h3>{stats.totalNotes}</h3>
              <p>Love Notes</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">✅</div>
            <div className="stat-info">
              <h3>{stats.completedTasks}</h3>
              <p>Tasks Done</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">🎯</div>
            <div className="stat-info">
              <h3>{stats.totalQuizzes}</h3>
              <p>Quizzes Created</p>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">💕</div>
            <div className="stat-info">
              <h3>{stats.daysConnected}</h3>
              <p>Days Together</p>
            </div>
          </div>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <Link 
              key={index} 
              to={feature.path} 
              className="feature-card"
              style={{ '--feature-color': feature.color }}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              {feature.count > 0 && (
                <div className="feature-count">{feature.count}</div>
              )}
            </Link>
          ))}
        </div>

        <div className="daily-motivation">
          <div className="motivation-card">
            <div className="heart-decoration">💖</div>
            <h3>Today's Love Thought</h3>
            <p>"Every love story is beautiful, but ours is my favorite" 💕</p>
          </div>
        </div>
      </div>
      
      <Navigation />
    </div>
  );
};

export default Dashboard;
